@if (displayMessages()) {
<div class="fixed z-1000 bg-accent bottom-0 sm:right-20 m-auto p-6 max-w-[540px] rounded-sm">
  <div class="actions flex items-center justify-between mb-6">
    @if (messagesFrontendFormat.length > 1) {
      <div>
        @for (message of messagesFrontendFormat; track message){
          @if(currentMessage && message.id == currentMessage.id){
            <button class="btn bg-transparent bg-none mr-4 border-[#4CB295]" (click)="setMessage(message)">{{ $index + 1 }}</button>
          } @else {
            <button class="btn bg-transparent bg-none mr-4 border-accent hover:border-[#4CB295]" (click)="setMessage(message)">{{ $index + 1 }}</button>
          }

        }
      </div>
    }

    <button (click)="close()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.4698 7.46973C15.7627 7.17683 16.2374 7.17683 16.5303 7.46973C16.8232 7.76262 16.8232 8.2374 16.5303 8.53027L13.0606 12L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2375 16.8231 15.7627 16.8231 15.4698 16.5303L12.0001 13.0605L8.53033 16.5303C8.23746 16.8231 7.76269 16.8231 7.46979 16.5303C7.17689 16.2374 7.17689 15.7626 7.46979 15.4697L10.9395 12L7.46979 8.53027C7.17689 8.23738 7.17689 7.76262 7.46979 7.46973C7.76268 7.17683 8.23744 7.17683 8.53033 7.46973L12.0001 10.9395L15.4698 7.46973Z" fill="#0A0A0A"/>
      </svg>
    </button>

  </div>
  <div class="whitespace-pre-wrap dark:text-base-100">{{currentMessage?.textBody}}</div>
</div>
}
